export const RefName = {
    CONTAINER: 'containerDom',
    CANVAS_WRAPPER: 'canvas-wrapper',
    NOTE_AREA: 'noteAreaRef',
    ZOOM: 'zoomContent',
    NAME_INPUT: 'nameInput',
};

export const DOMId = {
    CANVAS_WRAPPER: 'canvas-wrapper',
    AI_MODAL: 'slide-ai-talk-modal-wrapper',
    AI_MODAL_PAGE: 'slide-ai-talk-page-modal-wrapper',
    CANVAS: 'canvas',
    ZOOM_CONTENT: 'mobile-zoom-content',
    MULTI_SELECTED_DASH_OUTER: 'multi-selected-dash-outer',
    EXTRA_BUTTON_FOR_IFRAME_FOCUS: 'extra-button-for-iframe-focus',
};

export const LinkMode = {
    NOLINK: 0,
    AlWAYSHOW: 1,
    ENTERLEAVE: 2,
};

export const EDIT_PANEL_ID = 'edit-panel';
